export const PREFIX = 'https://api.belong.education';
// export const PREFIX = 'https://development-belong-api.herokuapp.com';
// export const PREFIX = 'http://localhost:5000';

export const UPLOAD_OR_DOWNLOAD_URL = `${PREFIX}/api/upload`;
export const API_URL = `${PREFIX}/api/v2`;
